import { render, staticRenderFns } from "./appCounter.vue?vue&type=template&id=33594f24"
import script from "./appCounter.vue?vue&type=script&lang=js"
export * from "./appCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports